import '../../invoice.scss';

import { func, number } from 'prop-types';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Col,
  FormGroup,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

import createModalToggle from '../../../../generic/create-modal-toggle';
import SingleSelect from '../../../../generic/SingleSelect';
import { isCollabary, isPC } from '../../../../layout/Variant/Variant';
import { COLORS } from '../../../../utils/constants';
import {
  cancellationReasonOptions,
  invoiceCancelationLink,
} from '../../../constants';

const isPCorCollabary = () => isPC() || isCollabary();
export function RequestCancellationModal({
  id,
  onRequestCancellation,
  toggle,
}) {
  const [cancellationReason, setCancellationReason] = useState(null);

  const requestCancellation = () => {
    return onRequestCancellation(id, cancellationReason).then(() => {
      toggle();
    });
  };

  const handleCancellationChange = e => {
    setCancellationReason(e.target.value);
  };

  return (
    <>
      <ModalHeader toggle={toggle}>
        Please provide reason for cancellation
      </ModalHeader>
      <ModalBody>
        <FormGroup row className="mb-0">
          <Col sm={12}>
            <SingleSelect
              options={cancellationReasonOptions}
              id="iv-cancellationReason"
              name="iv-cancellationReason"
              value={cancellationReason}
              onChange={handleCancellationChange}
            />
          </Col>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button onClick={requestCancellation} color="primary">
          Send
        </Button>
      </ModalFooter>
    </>
  );
}

export function RequestCancellationForPC() {
  return (
    <Link
      to={{ pathname: invoiceCancelationLink }}
      target="_blank"
      className="btn btn-outline-danger"
    >
      Request Cancellation
    </Link>
  );
}

RequestCancellationModal.propTypes = {
  id: number.isRequired,
  onRequestCancellation: func.isRequired,
  toggle: func.isRequired,
};

const RequestCancellation = isPCorCollabary()
  ? RequestCancellationForPC
  : createModalToggle(
      'Request Cancellation',
      RequestCancellationModal,
      { color: COLORS.DANGER, className: 'p-1', outline: true },
      { size: 'md' },
    );

export default RequestCancellation;
